define('home/models/activities/TrendingThreadActivity',[
    'home/models/activities/ThreadActivity',
], function (
    ThreadActivity
) {
    'use strict';

    /**
     * A thread is marked as "trending" by the system
     *
     * Relations {
     *     target: {
     *         type: 'thread',
     *         description: 'The thread that is identified as trending'
     *     }
     * }
     */
    return ThreadActivity.extend({
        defaults: {
            verb: 'trending',
        },
    });
});

